export const LogoSize = {
  large: { width: 310, height: 56 },
  default: { width: 180, height: 43 },
};
